/**
 * SHOPIFY EPIC ACCESSIBILITY & SEO ENGINE
 * ---------------------------------------
 * VERSION: 8.0.0 (Unified Core Build)
 * TARGET: WCAG 2.2 Level AA & SEO Optimization
 * ARCHITECTURE: Headless (Reads from window.EpicA11yConfig)
 */
window.ThemeEpic = (function($) {
    'use strict';
    let isProcessing = false;
    let lastBundleState = ''; 
    const config = window.EpicA11yConfig || { extensions: {}, navSelectors: {}, imageRules: [] };

    $(document).on('keydown', function(e) { if (e.key === 'Tab') { $('body').addClass('epic-is-tabbing'); } })
               .on('mousedown', function() { $('body').removeClass('epic-is-tabbing'); });

    // === NATIVE SVG LIBRARY (Replaces FontAwesome) ===
    const epicConfig = {
        svgs: {
            external: '<svg class="epic-svg-icon" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"/></svg>',
            pdf: '<svg class="epic-svg-icon" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM261.4 326c13.7 0 24.2 12 13.6 24.6-21.9-5.1-45-12.2-64.6-20.1 20-4.1 36.3-4.5 51-4.5zM320 0H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128L320 0zM224 128V32l96 96H224zm67 221c-9.1 16-35.3 43.1-94.8 54.4-19 33.6-38.3 56.4-56 56.4-13.8 0-21.3-9.5-21.3-21.3 0-16.7 13.9-39.2 46.3-64-11.2-24.3-21.2-50.5-27-75.1-23.2-16.4-44.5-28.8-44.5-43.1 0-14.1 14.5-27.2 32.7-27.2 17.5 0 28 17.5 31.8 31.4 2.1 7.7 1.4 16.5 .5 25.8 17.5-12.3 36.3-22.3 54.4-29.3 4-19 9.1-39.6 17.9-55.9 14.1-26.1 41.5-32 50.4-32 10.9 0 20.3 6.9 20.3 19.3 0 21.6-18.7 34.1-41.6 38.3-15.5 2.8-31.5 2.3-46.7 0-14.7 15.2-30.8 33-47.5 52.4 17.3 10.1 35.8 18 55.4 23.4 21.8-6.1 44.9-10.7 62-10.7 20.3 0 31.8 9.5 31.8 21.6 0 9.8-7.7 20-21.8 20z"/></svg>',
            chevronDown: '<svg class="epic-svg-icon" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>',
            chevronUp: '<svg class="epic-svg-icon" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/></svg>'
        }
    };

    const epicStrings = {
        'en': {
            skipMenu: 'Skip to Main Menu',
            skipContent: 'Skip to Content',
            skipFooter: 'Skip to Footer',
            addedToCart: 'added to your cart',
            bundleUpdated: 'Bundle updated.',
            total: 'Total:',
            removeFromBundle: 'Remove from bundle:',
            salePrice: 'Sale price:',
            originalPrice: 'Original price:',
            increaseQty: 'Increase quantity for',
            decreaseQty: 'Decrease quantity for',
            viewTranscript: 'View Transcript',
            hideTranscript: 'Hide Transcript'
        }
    };

    const t = (key) => {
        let lang = ($('html').attr('lang') || 'en').substring(0, 2).toLowerCase();
        return (epicStrings[lang] && epicStrings[lang][key]) ? epicStrings[lang][key] : (epicStrings['en'][key] || key);
    };

    const FocusRegistry = {
        cache: null,
        save: function() { this.cache = document.activeElement; },
        restore: function() { if (this.cache && typeof this.cache.focus === 'function') { this.cache.focus(); this.cache = null; } }
    };

    const executeMicroModules = () => {
        if (!$('html').attr('lang') || $('html').attr('lang').trim() === '') {
            $('html').attr('lang', (window.Shopify && window.Shopify.locale) ? window.Shopify.locale : 'en');
        }
        $('input[type="email"]:not([autocomplete])').attr('autocomplete', 'email');
        $('input[type="tel"]:not([autocomplete])').attr('autocomplete', 'tel');
        $('input[name*="firstname"], input[name*="first_name"]').not('[autocomplete]').attr('autocomplete', 'given-name');
        $('input[name*="lastname"], input[name*="last_name"]').not('[autocomplete]').attr('autocomplete', 'family-name');
        $('input[type="password"], input[type="email"], input[autocomplete="new-password"]').not('[name*="cc-number"], [name*="cvv"]').each(function() {
            $(this).removeAttr('onpaste ondrop oncopy');
        });
    };

    // === MODULE 1: CORE ACCESSIBILITY ===
    const normalizeHeadings = () => {
        let $primaryH1 = $('h1, [role="heading"][aria-level="1"]').not('.header__logo, .header__logo *, [aria-hidden="true"]').filter(':visible').first();
        if (!$primaryH1.length) {
            let $firstH2 = $('h2').not('.header__logo, [aria-hidden="true"]').filter(function() {
                return $(this).text().trim().length > 0 && $(this).is(':visible');
            }).first();
            if ($firstH2.length) {
                let $newH1 = $('<h1/>').html($firstH2.html());
                $.each($firstH2[0].attributes, function(i, attr) { $newH1.attr(attr.name, attr.value); });
                $firstH2.replaceWith($newH1);
                $primaryH1 = $('h1').first();
            }
        }
        let lastLevel = 1;
        $('h1, h2, h3, h4, h5, h6, [role="heading"]').each(function() {
            const $el = $(this);
            if ($el.hasClass('header__logo') || $el.closest('.header__logo').length) return;
            if (this.offsetWidth === 0 && this.offsetHeight === 0) return;
            if ($el.is($primaryH1)) { lastLevel = 1; return; }
            let cur = parseInt(this.tagName.substring(1)) || parseInt($el.attr('aria-level'));
            if (cur > lastLevel + 1) {
                $el.attr({ 'role': 'heading', 'aria-level': lastLevel + 1 });
                lastLevel++;
            } else if (cur) { lastLevel = cur; }
        });
    };

    const initSkipLinks = () => {
        if ($('.epic-skip-nav').length > 0) return;
        const menuTarget = $('header, .header-group, #shopify-section-header').first().attr('id') || 'epic-header-target';
        const contentTarget = $('main, [role="main"], #MainContent').first().attr('id') || 'epic-main-target';
        const footerTarget = $('footer, .footer-group').first().attr('id') || 'epic-footer-target';
        
        $('header').first().attr('id', menuTarget);
        $('main').first().attr('id', contentTarget);
        $('footer').first().attr('id', footerTarget);

        $('body').prepend(`
            <nav class="epic-skip-nav" aria-label="Skip navigation">
                <a href="#${menuTarget}" class="epic-skip-link">${t('skipMenu')}</a>
                <a href="#${contentTarget}" class="epic-skip-link">${t('skipContent')}</a>
                <a href="#${footerTarget}" class="epic-skip-link">${t('skipFooter')}</a>
            </nav>
        `);
    };

    const enforceLandmarks = () => {
        $('header, .header-group').first().attr('role', 'banner');
        $('footer, .footer-group').first().attr('role', 'contentinfo');
        const $mains = $('main, #MainContent, [role="main"]');
        $mains.first().attr('role', 'main');
        if ($mains.length > 1) {
            $mains.not(':first').each(function() {
                if ($(this).attr('role') === 'main') $(this).removeAttr('role');
                if (this.tagName.toLowerCase() === 'main') { $(this).attr('role', 'region'); }
            });
        }
        $('[role="main"] [role="main"], [role="banner"] [role="banner"]').removeAttr('role');
    };

    const fixAnimatedText = () => {
        $('split-words:not([data-epic-hydrated]), .split-words:not([data-epic-hydrated])').each(function() {
            const $split = $(this);
            $split.attr('data-epic-hydrated', 'true');
            const fullText = $split.text().replace(/\s+/g, ' ').trim();
            $split.attr('aria-hidden', 'true');
            if (fullText !== '') { $split.before(`<span class="sr-only">${fullText}</span>`); }
        });
    };

    const fixDecorativeVideos = () => {
        $('video[autoplay], video-media video').each(function() {
            const $vid = $(this);
            $vid.attr({'aria-hidden': 'true', 'tabindex': '-1', 'role': 'presentation'});
            if ($vid.find('track').length === 0) {
                $vid.append('<track kind="captions" src="data:text/vtt;base64,V0VCVlRUCg==" srclang="en" label="English" default>');
            }
        });
    };

    const normalizeVideoPosters = () => {
        $('.deferred-poster, [is="media-lightbox-button"], button.deferred-poster').each(function() {
            const $btn = $(this);
            if ($btn.attr('tabindex') === '-1' || !$btn.attr('tabindex')) { $btn.attr('tabindex', '0'); }
            $btn.find('.play-button[role="button"], [role="button"]').removeAttr('role');
        });
    };

    const hydrateExternalLinks = () => {
        const currentDomain = window.location.hostname;
        const orgs = config.orgs || [currentDomain];
        $('a[target="_blank"], a[href^="http"]:not([href*="' + currentDomain + '"]), a[href*="/pages/coa"]').not('.epic-handled-ext').each(function() {
            const $link = $(this).addClass('epic-handled-ext');
            const href = ($link.attr('href') || "").toLowerCase();
            if (!href || href.startsWith('#') || $link.hasClass('excludeMnitem')) return;
            const isPdf = href.includes('.pdf');
            const isExt = href.includes('http') && !orgs.some(org => href.includes(org));
            
            $link.attr({ 'target': '_blank', 'rel': 'noopener noreferrer' });
            if ($link.find('.epic-ext-warning').length === 0 && (isPdf || isExt)) {
                let payloadHtml = '<span class="sr-only"> (opens in a new tab)</span>';
                if (!$link.is('.epic-img-link, .media-card__link')) {
                    payloadHtml = (isPdf ? epicConfig.svgs.pdf : epicConfig.svgs.external) + payloadHtml;
                }
                $link.append(`<span class="epic-ext-warning icnSpacing">${payloadHtml}</span>`);
            }
        });
    };

    // === MODULE 2: UNIVERSAL NAVIGATION ===
    const initAccessibleNavigation = () => {
        if (!config.navSelectors || !config.navSelectors.parent) return;
        const s = config.navSelectors;
        let menuHoverTimer;

        $(s.dropdown).each(function() {
            $(this).find('a, button, input').attr('tabindex', '-1').addClass('epic-masked-link');
        });

        $(document).off('keydown.epicNav').on('keydown.epicNav', s.parent + ' > ' + s.trigger, function(e) {
            if (e.key === 'ArrowDown' || e.key === ' ') {
                e.preventDefault(); e.stopPropagation();
                const $li = $(this).closest(s.parent);
                const $dropdown = $li.find(s.dropdown).first(); 
                
                $(s.parent).filter('.epic-force-open').removeClass('epic-force-open')
                    .find(s.dropdown + ' a').attr('tabindex', '-1').addClass('epic-masked-link')
                    .end().find(s.trigger).attr('aria-expanded', 'false');

                $li.addClass('epic-force-open');
                $(this).attr('aria-expanded', 'true');
                $dropdown.find('.epic-masked-link').attr('tabindex', '0').removeClass('epic-masked-link');
                setTimeout(() => { $dropdown.find('a').first().focus(); }, 50);
            }
        });

        $(document).off('keydown.epicEsc').on('keydown.epicEsc', function(e) {
            if (e.key === 'Escape') {
                const $openLi = $(s.parent).filter('.epic-force-open, :hover');
                if ($openLi.length) {
                    e.stopPropagation();
                    $openLi.removeClass('epic-force-open');
                    const $dropdown = $openLi.find(s.dropdown);
                    $dropdown.css('display', 'none');
                    setTimeout(() => $dropdown.css('display', ''), 200); 
                    $openLi.find(s.trigger).first().attr('aria-expanded', 'false').focus();
                    $openLi.find(s.dropdown + ' a').attr('tabindex', '-1').addClass('epic-masked-link');
                }
            }
        });

        $(s.parent).off('mouseenter.epicNav').on('mouseenter.epicNav', function() {
            clearTimeout(menuHoverTimer); 
            const $dropdown = $(this).find(s.dropdown).first();
            $(this).find(s.trigger).attr('aria-expanded', 'true');
            $dropdown.find('a').attr('tabindex', '0').removeClass('epic-masked-link');
        }).off('mouseleave.epicNav').on('mouseleave.epicNav', function() {
            const $li = $(this);
            menuHoverTimer = setTimeout(() => {
                if (!$li.hasClass('epic-force-open')) {
                    const $dropdown = $li.find(s.dropdown).first();
                    $li.find(s.trigger).attr('aria-expanded', 'false');
                    $dropdown.find('a').attr('tabindex', '-1').addClass('epic-masked-link');
                }
            }, 250); 
        });

        $(s.parent + ' > ' + s.trigger).off('focus.epicNav').on('focus.epicNav', function() {
            const $parentLi = $(this).closest(s.parent);
            $parentLi.siblings('.epic-force-open').removeClass('epic-force-open')
                .find(s.dropdown + ' a').attr('tabindex', '-1').addClass('epic-masked-link')
                .end().find(s.trigger).attr('aria-expanded', 'false');
        });

        $(s.dropdown).off('keydown.epicNavTab').on('keydown.epicNavTab', 'a', function(e) {
            if (e.key === 'Tab') {
                e.preventDefault(); e.stopPropagation();
                const $dropdown = $(this).closest(s.dropdown);
                const $allDropdownLinks = $dropdown.find('a');
                const currentIndex = $allDropdownLinks.index(this);
                const isFirst = currentIndex === 0;
                const isLast = currentIndex === $allDropdownLinks.length - 1;

                if (e.shiftKey) {
                    if (isFirst) { $(this).closest(s.parent).find(s.trigger).first().focus(); } 
                    else { $allDropdownLinks.eq(currentIndex - 1).focus(); }
                } else {
                    if (isLast) {
                        const $parentLi = $(this).closest(s.parent);
                        $parentLi.removeClass('epic-force-open').find(s.trigger).first().attr('aria-expanded', 'false');
                        $dropdown.find('a').attr('tabindex', '-1').addClass('epic-masked-link');
                        const $nextItem = $parentLi.nextAll('.site-nav__item').first().find(s.trigger + ', a').first();
                        if ($nextItem.length) { $nextItem.focus(); } else { $('.site-nav__link--icon').first().focus(); }
                    } else {
                        $allDropdownLinks.eq(currentIndex + 1).focus();
                    }
                }
            }
        });
    };

    // === MODULE 3: IMAGE HYDRATION ===
    const hydrateImages = () => {
        if (!config.imageRules) return;
        config.imageRules.forEach(rule => {
            const $images = $(rule.selector).not('.epic-alt-fixed');
            if ($images.length > 0) {
                $images.each(function() {
                    const $img = $(this);
                    $img.attr('alt', rule.alt).addClass('epic-alt-fixed');
                    if (rule.removeRole) { $img.removeAttr('role'); }
                    if (rule.setRole) { $img.attr('role', rule.setRole); }
                });
            }
        });
    };

    // === MODULE 4: CART, QUANTITY & SUPPLEMENTS UI ===
    let speechLockTimer = null;
    let isSpeechLocked = false;

    const setupLiveRegion = () => {
        if (!$('#epic-live-region').length) {
            $('body').append('<div id="epic-live-region" aria-live="polite" aria-atomic="true" class="sr-only"></div>');
        }
    };

    const announceToScreenReader = (message, isPriorityAction = false) => {
        if (isSpeechLocked && !isPriorityAction) return;
        const $region = $('#epic-live-region');
        $region.text('');
        setTimeout(() => { 
            $region.text(message); 
            if (isPriorityAction) {
                isSpeechLocked = true;
                clearTimeout(speechLockTimer);
                speechLockTimer = setTimeout(() => { isSpeechLocked = false; }, 1500);
            }
        }, 100);
    };

    const normalizeSupplementsUI = () => {
        $('s, del, .price__compare, [data-product-bundle-total-with-currency], [data-product-bundle-total]').each(function() {
            const $el = $(this);
            if ($el.prev('.epic-price-label').length > 0 || $el.find('.epic-price-label').length > 0) return;
            if ($el.closest('.bundle-deal--unlocked, .price--on-sale, .price--sold-out, [data-bundle-discounted-total]').length || $el.is('s, del') || $el.hasClass('price__compare')) {
                $el.before(`<span class="sr-only epic-price-label">${t('originalPrice')} </span>`);
            }
        });
        $('.price__sale, [data-bundle-discounted-total], [data-bundle-discounted-total-mobile], .bundle-deal__newtotal').each(function() {
            const $el = $(this);
            if ($el.prev('.epic-price-label').length > 0 || $el.find('.epic-price-label').length > 0) return;
            $el.before(`<span class="sr-only epic-price-label">${t('salePrice')} </span>`);
        });
        $('product-bundle-remove-button:not([aria-label]), [data-action="remove"]:not([aria-label])').each(function() {
            const $btn = $(this);
            const itemName = $btn.closest('.horizontal-product, .cart-item').find('.horizontal-product__title, .cart-item__name').first().text().trim() || 'item';
            $btn.attr('aria-label', `${t('removeFromBundle')} ${itemName}`);
        });
        $('.quantity__button[aria-label*="{{ product }}"]').each(function() {
            const $btn = $(this);
            const itemName = $btn.closest('.horizontal-product, .product-card').find('.horizontal-product__title, .product-card__title').first().text().trim() || 'item';
            const isPlus = $btn.attr('name') === 'plus' || $btn.hasClass('plus');
            $btn.attr('aria-label', `${isPlus ? t('increaseQty') : t('decreaseQty')} ${itemName}`);
        });
        $('.free-shipping-bar__unlocked[role="status"], .marek-bundle-nudge[role="status"]').removeAttr('role');
    };

    const checkBundleMutations = () => {
        const $sidebar = $('.product-bundle__sidebar');
        if (!$sidebar.length || !$sidebar.is(':visible')) return;
        const goalText = $sidebar.find('.bundle-goal, [data-bundle-goal], [data-bundle-deal-msg]').filter(':visible').first().text().replace(/\s+/g, ' ').trim();
        let currentTotal = $sidebar.find('[data-bundle-discounted-total]').filter(':visible').first().text().trim();
        if (!currentTotal) {
            currentTotal = $sidebar.find('[data-product-bundle-total-with-currency]').filter(':visible').first().text().trim();
        }
        const currentState = `${goalText} | ${currentTotal}`;
        if (currentState !== ' | ' && currentState !== lastBundleState && lastBundleState !== '') {
            const speechPayload = `${t('bundleUpdated')} ${goalText} ${currentTotal ? t('total') + ' ' + currentTotal : ''}`;
            announceToScreenReader(speechPayload.replace(/\|\s*/g, '').trim());
        }
        lastBundleState = currentState;
    };

    const initCartControls = () => {
        $(document).off('click.epicCartDrawer').on('click.epicCartDrawer', '.marek-stepper__btn, .marek-cart-remove', function(e) {
            const $btn = $(this);
            const $row = $btn.closest('.horizontal-product');
            const itemName = $row.find('.horizontal-product__title').first().text().trim() || 'Item';
            if ($btn.hasClass('marek-cart-remove') || $btn.is('[is="cart-remove-button"]')) {
                announceToScreenReader(`${itemName} removed from cart.`, true); 
            } else if ($btn.hasClass('marek-stepper__btn--plus') || $btn.attr('name') === 'plus') {
                announceToScreenReader(`Increased quantity for ${itemName}.`, true);
            } else if ($btn.hasClass('marek-stepper__btn--minus') || $btn.attr('name') === 'minus') {
                announceToScreenReader(`Decreased quantity for ${itemName}.`, true);
            }
        });

        $(document).off('click.epicCart').on('click.epicCart', 'form[action*="/cart/add"] [type="submit"], .add-to-cart, [name="add"]', function(e) {
            if (!e.originalEvent) return;
            const $btn = $(this), $form = $btn.closest('form');
            if ($form.is('[is="product-bundle-form"]') || $form.closest('.product-bundle-wrapper, product-bundle').length > 0 || $btn.attr('aria-controls')?.includes('ProductBundle')) {
                return;
            }
            FocusRegistry.save();
            setTimeout(() => {
                if ($form.find('.product-form__error-message, .alert--error').filter(':visible').length > 0) return;
                const $activeDrawer = $('.is-open, .is-active, [aria-expanded="true"]').filter('.cart-drawer, #CartDrawer, .drawer');
                if ($activeDrawer.length > 0 && $activeDrawer.is(':visible')) {
                    $activeDrawer.find('h1, h2, h3, .drawer__title').first().attr('tabindex', '-1').focus();
                    return;
                }
                let productName = $form.find('[name="id"] option:selected').text() || $form.closest('.product, .card').find('.product-title, h1, h2').first().text() || "Item";
                const message = `${productName.replace(/\s+/g, ' ').trim()} ${t('addedToCart')}`;
                announceToScreenReader(message, true);
            }, 1000);
        });
    };

    // === MODULE 5: THIRD-PARTY WIDGETS ===
    const manageThirdPartyWidgets = () => {
        const observer = new MutationObserver(() => {
            if (config.extensions && config.extensions.optinMonster) {
                const $modal = $('.om-overlay:not(.epic-om-fixed)');
                if ($modal.length) {
                    $modal.find('input[type="email"]').attr('aria-label', 'Email address');
                    $modal.find('.om-popup-close-x, .om-global-close-button').attr({'role': 'button', 'aria-label': 'Close dialog', 'tabindex': '0'});
                    $modal.off('keydown.epicOM').on('keydown.epicOM', function(e) {
                        if (e.key === 'Escape') { $modal.find('.om-popup-close-x').click(); }
                    });
                    $modal.addClass('epic-om-fixed');
                }
            }
            const chat = document.querySelector('shopify-chat');
            if (chat && chat.shadowRoot) {
                const runtime = chat.shadowRoot.querySelector('shopify-agent-runtime');
                if (runtime && runtime.shadowRoot) {
                    const dialog = runtime.shadowRoot.querySelector('section[part="dialog"]');
                    if (dialog && !dialog.querySelector('.epic-chat-bumper')) {
                        const bumperStyle = 'position: absolute; opacity: 0; pointer-events: none; width: 1px; height: 1px;';
                        const topBumper = document.createElement('div');
                        topBumper.className = 'epic-chat-bumper'; topBumper.style.cssText = bumperStyle; topBumper.tabIndex = 0;
                        const bottomBumper = document.createElement('div');
                        bottomBumper.className = 'epic-chat-bumper'; bottomBumper.style.cssText = bumperStyle; bottomBumper.tabIndex = 0;
                        dialog.insertBefore(topBumper, dialog.firstChild);
                        dialog.appendChild(bottomBumper);
                        const bounceFocus = (toIframe) => {
                            if (!chat.hasAttribute('open')) return;
                            const buttons = Array.from(dialog.querySelectorAll('shopify-sign-in-button:not([hidden]), shopify-chat-icon-button:not([hidden])'));
                            const iframe = dialog.querySelector('iframe');
                            if (toIframe && iframe) { iframe.focus(); } 
                            else if (!toIframe && buttons.length > 0) {
                                const firstHost = buttons[0];
                                const innerBtn = firstHost.shadowRoot ? firstHost.shadowRoot.querySelector('button') : firstHost;
                                innerBtn.focus();
                            }
                        };
                        bottomBumper.addEventListener('focus', () => bounceFocus(false));
                        topBumper.addEventListener('focus', () => bounceFocus(true));
                    }
                }
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    };

    // === MODULE 6: ASYNC POLLING ===
    const runAsyncFixes = () => {
        let elapsed = 0;
        const asyncInterval = setInterval(() => {
            if (config.extensions && config.extensions.pagefly) {
                const sections = [
                    { id: 'epic-finishes', targetText: 'Our Signature Finishes' },
                    { id: 'epic-cuffs', targetText: 'Cuffs' },
                    { id: 'epic-links', targetText: 'Link Bracelets' },
                    { id: 'epic-rings', targetText: 'Rings' },
                    { id: 'epic-necklaces', targetText: 'Necklace Lengths' }
                ];
                sections.forEach(sec => {
                    const $target = $('h1, h2, h3, p').filter(function() {
                        const inMenu = $(this).closest('div[data-to-section]').length > 0 || $(this).closest('.epic-anchor-fixed').length > 0;
                        return !inMenu && $(this).text().trim() === sec.targetText && !$(this).hasClass('epic-id-set');
                    }).first(); 
                    if ($target.length) { $target.attr({'id': sec.id, 'tabindex': '-1'}).addClass('epic-id-set'); }
                });
                $('.sc-cTAqQK').eq(1).find('div[data-to-section]').each(function(index) {
                    const $div = $(this);
                    if ($div.hasClass('epic-anchor-fixed')) return; 
                    if (index < sections.length) {
                        $div.addClass('epic-anchor-fixed'); 
                        const linkText = $div.text().trim();
                        const targetId = sections[index].id;
                        $div.find('span').css({'color': '', 'text-decoration-line': ''});
                        const innerHTML = $div.html();
                        const $anchor = $(`<a href="#${targetId}" class="epic-anchor-link" aria-label="Jump to ${linkText} section"></a>`).html(innerHTML);
                        $div.removeAttr('data-to-section data-offset href').empty().append($anchor);
                    }
                });
                
                const $hiddenH1s = $('h1.sr-only:contains("About Us")');
                if ($hiddenH1s.length > 0 && !$hiddenH1s.first().hasClass('epic-h1-fixed')) {
                    $hiddenH1s.first().addClass('epic-h1-fixed');
                    $hiddenH1s.not('.epic-h1-fixed').remove();
                }

                $('.pf-table-default table:not(.epic-table-fixed)').each(function() {
                    const $table = $(this);
                    const $tbody = $table.find('tbody');
                    const $rows = $tbody.find('tr');
                    if ($rows.length > 2) {
                        $table.addClass('epic-table-fixed');
                        const $titleRow = $rows.eq(0);
                        const $headerRow = $rows.eq(1);
                        const titleText = $titleRow.find('th, td').first().text().trim();
                        const $thead = $('<thead></thead>');
                        $headerRow.find('th, td').replaceWith(function() { return $(`<th scope="col">${$(this).html()}</th>`); });
                        $thead.append($headerRow);
                        $titleRow.remove();
                        $table.prepend($thead);
                        if (titleText && titleText !== "") { $table.prepend(`<caption>${titleText}</caption>`); }
                    }
                });

                if (!window.epicPfClickBound) {
                    document.addEventListener('click', function(e) {
                        const anchor = e.target.closest('.epic-anchor-link');
                        if (anchor) {
                            e.preventDefault(); e.stopPropagation(); 
                            const targetId = anchor.getAttribute('href');
                            const $target = $(targetId);
                            if ($target.length) {
                                $('html, body').animate({ scrollTop: $target.offset().top - 120 }, 400);
                                $target.attr('tabindex', '-1').focus();
                            }
                        }
                    }, true); 
                    window.epicPfClickBound = true;
                }
            }

            if (config.extensions && config.extensions.inlineContrast) {
                const failingColors = ['rgb(245, 166, 35)', 'rgb(219, 157, 95)'];
                failingColors.forEach(color => {
                    const colorNoSpace = color.replace(/ /g, '');
                    const $failingElements = $(`span[style*="${color}"], span[style*="${colorNoSpace}"], a[style*="${color}"], a[style*="${colorNoSpace}"]`);
                    if ($failingElements.length > 0) {
                        $failingElements.each(function() {
                            const $el = $(this);
                            if (!$el.hasClass('epic-contrast-fixed')) {
                                $el.css('color', '').addClass('epic-contrast-fixed');
                            }
                        });
                    }
                });
            }

            elapsed += 500;
            if (elapsed >= 8000) clearInterval(asyncInterval);
        }, 500);
    };

    // === MODULE 7: MEDIA TRANSCRIPTS (SVG Driven) ===
    const handleMediaTranscripts = () => {
        if (!config.mediaTranscripts) return;
        Object.keys(config.mediaTranscripts).forEach(videoId => {
            const $mediaTarget = $(`iframe[src*="${videoId}"], video[data-id="${videoId}"], [data-video-id="${videoId}"], source[src*="${videoId}"]`).closest('video, iframe, video-media, .product__media');
            $mediaTarget.each(function() {
                if ($(this).parent().find('.epic-transcript-wrapper').length === 0) {
                    const id = 'transcript-' + Math.random().toString(36).substr(2, 9);
                    $(this).after(`
                        <div class="epic-transcript-overlay epic-transcript-wrapper" style="margin-top: 1rem; width: 100%;">
                            <button type="button" class="transBtn trnsBtn toggle-transcript-addon-btn" aria-expanded="false" aria-controls="${id}" style="width: 100%; display: flex; justify-content: space-between; align-items: center; margin-bottom: 0 !important; background: #fff; border: 1px solid #ccc; padding: 10px; cursor: pointer;">
                                <span class="btn-text">${t('viewTranscript')}</span>
                                <span class="epic-icon-wrapper" style="margin-left: 10px; width: 14px; display: inline-flex;">
                                    ${epicConfig.svgs.chevronDown}
                                </span>
                            </button>
                            <div id="${id}" class="transcript-content" hidden style="padding: 1.5rem; border: 1px solid #1C479A; border-top: none; background: #ffffff; color: #000000; text-align: left; font-size: 15px; line-height: 1.6;">
                                ${config.mediaTranscripts[videoId]}
                            </div>
                        </div>
                    `);
                }
            });
        });

        $(document).off('click.epicAddon').on('click.epicAddon', '.toggle-transcript-addon-btn', function() {
            const isExpanded = $(this).attr('aria-expanded') === 'true';
            $(this).attr('aria-expanded', !isExpanded).find('.btn-text').text(isExpanded ? t('viewTranscript') : t('hideTranscript'));
            $(this).find('.epic-icon-wrapper').html(isExpanded ? epicConfig.svgs.chevronDown : epicConfig.svgs.chevronUp);
            $('#' + $(this).attr('aria-controls')).prop('hidden', isExpanded);
        });
    };

    // === MODULE 8: PDP GALLERY NORMALIZATION ===
    const remediatePDPGallery = () => {
        $('.product__media-container[tabindex="0"], .product__gallery[tabindex="0"], [data-section-id*="main-product"] .product-gallery-wrapper[tabindex="0"], .product-single__media-slider[tabindex="0"]').removeAttr('tabindex');
        $('.product__media-item, .product-gallery__thumbnail, [data-pswp-src], .pswp__img, .product__thumb, .product-single__media').each(function(index) {
            const $item = $(this);
            if (this.tagName !== 'BUTTON' && this.tagName !== 'A') {
                if (!$item.attr('tabindex')) { $item.attr({ 'tabindex': '0', 'role': 'button' }); }
                if (!$item.attr('aria-label')) {
                    const altText = $item.attr('alt') || $item.find('img').attr('alt') || `Product image ${index + 1}`;
                    $item.attr('aria-label', `View ${altText} in gallery view`);
                }
            }
        });
        $(document).off('keydown.epicGallery').on('keydown.epicGallery', '.product__media-item[role="button"], .product-gallery__thumbnail[role="button"], [data-pswp-src][role="button"], .pswp__img[role="button"], .product__thumb[role="button"], .product-single__media[role="button"]', function(e) {
            if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
                e.preventDefault(); this.click(); 
            }
        });
    };

    // === MODULE 9: STAMPED.IO REVIEWS ===
    const handleStampedReviews = () => {
        $('.stamped-badge, .stamped-badge-caption, .stamped-main-badge, .stamped-starratings').each(function() {
            const currentRole = $(this).attr('role');
            if(!currentRole || currentRole === 'list') $(this).attr('role', 'note');
        });
        const $reviewForm = $('.new-review-form.stamped-visible');
        $reviewForm.off('keydown.epicEscape').on('keydown.epicEscape', function(e) {
            if (e.key === 'Escape') {
                const $toggleBtn = $('.stamped-main-badge-write, .stamped-button-write');
                if ($toggleBtn.length) { $toggleBtn.click().focus(); e.preventDefault(); e.stopPropagation(); }
            }
        });
        const $stars = $reviewForm.find('.stamped-fa, .stamped-starrating a');
        if ($stars.length > 0) {
            $stars.attr('tabindex', '-1');
            let $targetStar = $stars.filter('.fa-star-checked').first();
            if (!$targetStar.length) $targetStar = $stars.first();
            $targetStar.attr('tabindex', '0');
            $stars.off('keydown.epicReview').on('keydown.epicReview', function(e) {
                if (e.key === 'Tab' && !e.shiftKey) {
                    const $next = $('input[name="reviewTitle"], #review_title_' + $reviewForm.find('[name="productId"]').val());
                    if ($next.length) { $next.focus(); e.preventDefault(); }
                }
            });
        }
    };

    // === CORE PIPELINE EXECUTION ===
    const runCorePipeline = () => {
        executeMicroModules();
        normalizeHeadings();
        initSkipLinks();
        enforceLandmarks();
        fixAnimatedText();
        fixDecorativeVideos();
        normalizeVideoPosters();
        hydrateExternalLinks();
        initAccessibleNavigation();
        hydrateImages();
        normalizeSupplementsUI();
        checkBundleMutations();
        remediatePDPGallery();
        
        if (config.extensions && config.extensions.stampedReviews) { handleStampedReviews(); }
        if (config.extensions && config.extensions.mediaTranscripts) { handleMediaTranscripts(); }
        
        if (typeof config.customOverrides === 'function') {
            try { config.customOverrides(); } catch (e) { console.error('Epic Engine: Custom overrides failed', e); }
        }
    };

    const initObserver = () => {
        let debounceTimer;
        const observer = new MutationObserver(() => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                observer.disconnect();
                runCorePipeline();
                requestAnimationFrame(() => { observer.observe(document.body, { childList: true, subtree: true, attributes: true }); });
            }, 250);
        });
        observer.observe(document.body, { childList: true, subtree: true, attributes: true });
    };
    
    return {
        init: () => {
            setupLiveRegion();
            runCorePipeline();
            initCartControls();
            manageThirdPartyWidgets();
            runAsyncFixes();
            initObserver();
            console.log(`Epic Engine v8.0.0 Booted. Theme: ${config.theme || 'Unknown'}`);
        }
    };
})(window.jQuery || window.$);

document.addEventListener('DOMContentLoaded', () => {
    if (window.ThemeEpic && typeof window.ThemeEpic.init === 'function') { window.ThemeEpic.init(); }
});